<template>
  <dh-header>
    Manage Employees
    <template #buttons>
      <dh-button icon="export" variant="none" class="text-gray-500" @click="exportToCsv">Export to CSV</dh-button>
      <dh-button icon="add" variant="none" class="text-yellow-300" route="employees.create">Add Employee</dh-button>
    </template>
  </dh-header>
  <dh-table :rows="rows" :loading="loading" row-route="employees.edit" :row-params="row => ({ id: row.id })">
    <dh-table-column label="Name" v-slot="{ row }">{{ row.individual?.firstName }} {{ row.individual?.lastName }}</dh-table-column>
    <dh-table-column label="Phone" :value="row => row.individual?.phoneNumber"></dh-table-column>
    <dh-table-column label="Email" :value="row => row.username"></dh-table-column>
    <dh-table-column label="Type" :value="row => row.employeeData?.type"></dh-table-column>
    <dh-table-column label="Role" :value="row => row.roleName"></dh-table-column>
    <dh-table-column label="Status" :value="row => row.status"></dh-table-column>
  </dh-table>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DhHeader from "@/components/DhHeader.vue";
import DhTable from "@/components/DhTable.vue";
import DhTableColumn from "@/components/DhTableColumn.vue";
import DhButton from "@/components/DhButton.vue";
import { users } from "@/api";
import { useRemoteList } from "@/hooks/useRemoteList";
import {useExportToCsv} from "@/hooks/useExportToCsv";

export default defineComponent({
  name: "Employees",
  components: {
    DhButton,
    DhHeader,
    DhTable,
    DhTableColumn,
  },
  setup() {
    const [rows, pagination, loading] = useRemoteList(users.list);

    const exportToCsv = useExportToCsv({
      filename: "users.csv",
      action: () =>
        rows.value.map(user => ({
          Name: [user.individual?.firstName, user.individual?.lastName].filter(Boolean).join(" "),
          Phone: user.individual?.phoneNumber,
          Email: user.username,
          Type: user.employeeData?.type,
          Status: user.status,
        })),
    });

    return { rows, loading, exportToCsv };
  },
});
</script>
